import { FormControl as MuiFormControl, styled, FormControlProps } from '@material-ui/core';
import { compose, sizing, spacing, SizingProps, SpacingProps } from '@material-ui/system';

const FormControl = styled(MuiFormControl)(compose(sizing, spacing));

export type FormControlEnhancedProps = FormControlProps & SizingProps & SpacingProps;

export default FormControl;
